import { createBrowserHistory } from 'history'
const history = createBrowserHistory()
window.global_history = history
export default history
